import { request } from '@/shared/api/request'

export const getXml = (externalId) => {
	return request({ url: 'contract/get/' + externalId + '/xml', method: 'GET' })
}

export const getEditXml = (payload) => {
	return request({ url: 'contract/get/xml', method: 'POST', data: payload })
}
